const observerTargets = {
	height: 'offsetHeight',
	width: 'offsetWidth',
};

const buildSizeObserver = (el, slug, variableName, target = 'height') => {
	if (!el) return;
	const targetSize = observerTargets[target];
	const observer = new ResizeObserver(([entry]) => {
		window.requestAnimationFrame(() => {
			document.documentElement.style.setProperty(
				variableName,
				entry.target[targetSize] + 'px'
			);
			Object.assign(window, {
				observers: {
					...window.observers,
					[slug]: { height: entry.target[targetSize] },
				},
			});
		});
	});
	observer.observe(el);
};

const buildInertObserver = (el) => {
	const inertObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'attributes') {
				const target = mutation.target;
				if (target.classList.contains('inert')) {
					target.inert = true;
				} else {
					target.inert = false;
				}
			}
		});
	});
	inertObserver.observe(el, { attributes: true });
};

const convertInertClassToAttribute = () => document.querySelectorAll('.inert').forEach(el => el.inert = true);

export { buildSizeObserver, buildInertObserver, convertInertClassToAttribute };
